import React, { useEffect, useState } from 'react';
import { useGetBookingList } from '../../hooks/react-query/useAdmin';
import { Mapper } from '../../utils/user/mapper';
import { Table } from '../../components/ui/Table';
import { PageTitle } from '../../components/ui';
import { HeaderToolBar } from '../../components/elements/headerToolBar';
import Pagination from '../../components/elements/pagination/pagination';

import {
  exportToFile,
  generatePdfDocument,
} from '../../utils/importDriver/funtions';
import { TableSkeletion } from '../../components/elements/skeletions';
import Container from '../../components/elements/container';
import { BookingPageTitle } from '../../components/admin/bookinPageTitle';
import {
  TableBodyComponent,
  TableHeadersComponent,
} from '../../components/admin/table';
import { NoDataFound } from '../../components/elements/noDataFound';
import Loader from '../../components/elements/loader';

const BookingReporting = () => {
  const [bookingList, setBookingList] = useState();
  const [openColumnListModal, setCoumnListModal] = useState(false);
  const [selectedColumns, setSavedColumns] = useState([]); //

  const [filterState, setFilterState] = useState({
    length: 100,
    orderType: 'asc',
    orderBy: 'id',
    search: '',
    page: 1,
  });

  const { data: bookingData, isLoading } = useGetBookingList(filterState);

  useEffect(() => {
    if (bookingData && bookingData.pages && bookingData.pages[0].data) {
      setBookingList(Mapper(bookingData.pages[0], 'bookingReporting'));
    }
  }, [bookingData]);

  const handleExport = (type) => {
    if (type === 'pdf') {
      generatePdfDocument(bookingList, 'booking_reports');
    } else {
      exportToFile(bookingList, type, 'booking_reports');
    }
  };

  const handleSortOrder = (item) => {
    let orderBy = item.name;
    let orderType = 'asc';
    if (item.name !== filterState?.orderBy) {
      orderBy = item.name;
    } else {
      orderType = filterState.orderType === 'asc' ? 'desc' : orderType;
    }

    setFilterState((prev) => ({ ...prev, orderType, orderBy, page: 1 }));
  };

  const handleSearch = (searchKey) => {
    setFilterState((prev) => ({ ...prev, search: searchKey, page: 1 }));
  };

  const handlePagination = (pageNum) => {
    setFilterState((prev) => ({ ...prev, page: pageNum }));
  };

  const handleColumnSave = (columns) => {
    setSavedColumns(columns);
    setCoumnListModal(false);
  };

  const handlePerPageDataFetch = (value) => {
    setFilterState((prev) => ({ ...prev, length: value }));
  };

  if (isLoading && !bookingList) {
    return (
      <Container className="max-lg:px-0">
        <TableSkeletion />
      </Container>
    );
  }
  if (!bookingList || !bookingList.data) {
    return (
      <Container>
        <NoDataFound />
      </Container>
    );
  }

  return (
    <>
      {isLoading && bookingList && <Loader />}
      <Container className="py-10 flex flex-col gap-6 overflow-y-auto max-h-[88vh] max-lg:px-0">
        <PageTitle
          displaySearch={false}
          titleText={false}
          wrapperClassName="flex-col max-lg:px-5"
          titleComponent={<BookingPageTitle />}
          endComponent={
            <HeaderToolBar
              showPageList={true}
              dataPerPageCount={filterState?.length}
              openColumnListModal={openColumnListModal}
              handleSearch={handleSearch}
              searchTerm={filterState.search}
              configurations={bookingList}
              columnList={bookingList?.columns}
              handleExport={handleExport}
              selectedColumns={selectedColumns}
              handleColumnSave={handleColumnSave}
              handleColumnListClick={(value) => setCoumnListModal(value)}
              handlePerPageDataFetch={handlePerPageDataFetch}
            />
          }
        />

        <Table wrapperClassName="p-2 lg:p-4 scrollbar overflow-auto max-lg:rounded-none max-lg:min-h-[250px]">
          <TableHeadersComponent
            selectedColumns={selectedColumns}
            tableData={bookingList}
            handleSortOrder={handleSortOrder}
          />
          <TableBodyComponent
            tableData={bookingList}
            selectedColumns={selectedColumns}
          />
        </Table>

        <Pagination
          currentPage={bookingList?.pagination?.current_page}
          totalCount={bookingList?.records?.total}
          pageSize={filterState.length}
          onPageChange={handlePagination}
          from={bookingList?.records.from}
          to={bookingList?.records.to}
        />
      </Container>
    </>
  );
};

export default BookingReporting;
